import makeQueryKey from "../../../utils/make-query-key";
var getIdentityQueryKey = function getIdentityQueryKey() {
  return makeQueryKey(['webShellClient', 'identity']);
};
export default getIdentityQueryKey;